type LinkIconProps = {
  className?: string;
};

export const LinkIcon = ({ className }: LinkIconProps) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" className={className} fill="none">
      <g id="Icon/Link">
        <mask id="mask0_17773_34266" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="20">
          <rect id="Bounding box" x="0.5" width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_17773_34266)">
          <path
            id="Icon"
            d="M12.8599 13.5355L10.5029 15.8926C9.68776 16.7077 8.70567 17.1153 7.55662 17.1153C6.40757 17.1153 5.42548 16.7077 4.61034 15.8926C3.7952 15.0774 3.38764 14.0953 3.38764 12.9463C3.38764 11.7972 3.7952 10.8151 4.61034 10L6.96736 7.64299L8.14587 8.8215L5.78885 11.1785C5.29781 11.6696 5.05228 12.2588 5.05228 12.9463C5.05228 13.6338 5.29781 14.223 5.78885 14.7141C6.2799 15.2051 6.86915 15.4506 7.55662 15.4506C8.24408 15.4506 8.83334 15.2051 9.32439 14.7141L11.6814 12.357L12.8599 13.5355ZM8.73513 12.9463L7.55662 11.7678L12.2707 7.05373L13.4492 8.23224L8.73513 12.9463ZM14.0384 12.357L12.8599 11.1785L15.2169 8.8215C15.708 8.33045 15.9535 7.7412 15.9535 7.05373C15.9535 6.36627 15.708 5.77701 15.2169 5.28597C14.7259 4.79492 14.1366 4.5494 13.4492 4.5494C12.7617 4.5494 12.1725 4.79492 11.6814 5.28597L9.32439 7.64299L8.14587 6.46448L10.5029 4.10745C11.318 3.29232 12.3001 2.88475 13.4492 2.88475C14.5982 2.88475 15.5803 3.29232 16.3955 4.10745C17.2106 4.92259 17.6182 5.90468 17.6182 7.05373C17.6182 8.20278 17.2106 9.18487 16.3955 10L14.0384 12.357Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
